import { render, staticRenderFns } from "./AnnualReturnsTask.vue?vue&type=template&id=097664f9&scoped=true&"
import script from "./AnnualReturnsTask.vue?vue&type=script&lang=js&"
export * from "./AnnualReturnsTask.vue?vue&type=script&lang=js&"
import style0 from "./AnnualReturnsTask.vue?vue&type=style&index=0&id=097664f9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "097664f9",
  null
  
)

export default component.exports